import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import FieldText from '../common/FieldText';
import FieldSelect from '../common/FieldSelect';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import MassWhatsAppAPI from '../../api/MassWhatsAppAPI';
import ValidationController from '../../controller/ValidationController';
import ApiUiController from '../../controller/ApiUiController';
import ViewController from "../../controller/ViewController";

class MassWhatsAppPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).mass_whatsapp;
    this.mass_whatsapp = {
      id: 0, name: "", template: 0, operation_status: 1,
      module: props.model_no
    };
    this.state = { inApiCall: false, inValid: {}, mass_whatsapp: { ...this.mass_whatsapp } };
  }

  onChange = (field, value) => {
    const mass_whatsapp = { ...this.state.mass_whatsapp };
    mass_whatsapp[field] = value;
    this.setState({ ...this.state, mass_whatsapp: { ...mass_whatsapp } });
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.mass_whatsapp);
    if (inValid === null) {
      const mass_whatsapp = { ...this.state.mass_whatsapp };
      const mainFilters = ViewController.getRestrictionsView(this.props.model_no);
      mass_whatsapp.filters = ViewController.filters(this.props.listFilters, this.props.viewFilters, mainFilters, 
        this.props.restrict);
      MassWhatsAppAPI.save(mass_whatsapp, this.onSaved, this.onFail);
      this.setState({ ...this.state, inApiCall: true });
    } else { 
      this.setState({ ...this.state, inValid: { ...inValid } }); 
    }
  }

  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };

  onSaved = res => {
    Util.showNotification('Successful', 'Mass WhatsApp saved successfully', 'success');
    this.setState({ ...this.state, mass_whatsapp: { ...this.state.mass_whatsapp, id: res.id }, inApiCall: false });
    this.props.onHide();
    if (this.props.reload) {
      this.props.reload();
    }
  }

  render() {
    const fields = this.model.fields;
    const mass_whatsapp = this.state.mass_whatsapp;
    const inValid = this.state.inValid;
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false}>

        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Send Mass WhatsApp</Modal.Title>
        </Modal.Header>
        <ApiUiController inApiCall={this.state.inApiCall}>
          <Modal.Body>
            <Form>
              <FieldText key="name" id="name" field={fields.name}
                value={mass_whatsapp.name} onValueChange={this.onChange} inValid={inValid} />

              <FieldSelect key="template" id="template"
                field={fields.template} value={mass_whatsapp.template}
                onValueChange={this.onChange} inValid={inValid} />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onSave}>Submit</Button>
          </Modal.Footer>
        </ApiUiController>
      </Modal>
    );
  }
}
export default MassWhatsAppPopup;